import Header from "./components/Header";
import Hero from "./components/Hero";
import Channels from "./components/Channels";
import Discuss from "./components/Discuss";
import Opinion from "./components/Opinion";
import Timeline from "./components/Timeline";
import Rising from "./components/Rising";
import Topics from "./components/Topics";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Channels />
        <Discuss />
        <Opinion />
        <Timeline />
        <Rising />
        <Topics />
      </main>
      <Footer />
    </div>
  );
}